module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_zh-hans-b3606ec812d42f2dc9ae01d12a20ce04.jpg";